<template>
  <div class="container-fluid">
        <div class="row centro justify-content-center">
            <div class="col-md-6 align-self-center">
                <div class="form-box mx-auto">
                    <img src="../assets/logo.png" alt="Editora do Brasil" class="img-fluid mx-auto d-block">
                    <form id="recupForm" @submit.prevent="recuperar">
                        <div class="form-group">
                            <label for="recupEmail" class="label">E-mail</label>
                            <div class="input-group">
                                <input type="email" id="recupEmail" v-model="recup.Email" class="form-control" maxlength="100">
                            </div>
                        </div>
                        <div class="form-group">
                            <div id="recupMsg" class="alert alert-success fade show" role="alert">
                                Você receberá em seu E-mail as informações para recuperar sua senha.
                            </div>
                        </div>
                        <div class="form-group">
                            <button @click.prevent="recuperar" class="btn btn-submit btn-block">Recuperar senha</button>
                        </div>
                        <div class="form-group">
                            <router-link to="/" class="btn btn-recuperar btn-block">Voltar</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {http} from '../services/APIservice'

export default {
    name: 'recuperar-senha',
    data() {
        return {
            recup: {
                Email: ''
            }
        }
    },
    methods: {
        recuperar() {
            document.getElementById('recupMsg').style.display = 'block';
            return http.get(`Usuario/RecuperarSenha?email=${this.recup.Email}`).then(response => {

                // console.log(response.data.usuario)
                console.log(response.status)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }
}
</script>
